<template>
  <el-row class="full-height" :gutter="10" style="margin: 0px; padding: 10px 4px">
    <el-col class="full-height" :span="8">
      <el-container class="full-height">
        <el-header height="auto" class="no-padding">
          <el-form size="small" label-position="top">

            <el-row :gutter="10">
              <el-col :span="12">
                <el-form-item label="Nome">
                  <el-input size="small" v-model="formPesquisa.nome" @keyup.enter.native="handlerListarCidades"/>
                </el-form-item>         
              </el-col>
              <el-col :span="6">
                <el-form-item label="UF">
                  <el-select
                    v-model="formPesquisa.estado.id"
                    size="small"
                    clearable
                    clear
                  >
                    <el-option
                      v-for="item in estados"
                      :key="item.id"
                      :label="item.sigla"
                      :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col>
                <el-button @click="limparForm" size="small" type="success">Novo</el-button>
                <el-button @click="handlerListarCidades" size="small" type="primary">Pesquisar</el-button>
                <el-button @click="limparFormPesquisa" size="small" type="warning">Limpar</el-button>
              </el-col>
            </el-row>

            <el-row style="margin-top: 10px">
              <el-col>
                <span style="font-size: 14px; color: #777">{{ labelQuantidadeCidades }}</span>
              </el-col>
            </el-row>

          </el-form>
        </el-header>

        <el-main style="height: 100%; padding: 0px; margin-top: 10px">
          <el-table
            @row-dblclick="handleRecuperarCidade"
            :data="listaCidades"
            empty-text="Nenhuma Cidade"
            height="100%"
            size="small"
            highlight-current-row
            stripe
          >
            <el-table-column label="Estado">
              <template slot-scope="scope">
                {{ scope.row.estado.nome }}
              </template>
            </el-table-column>
            <el-table-column label="Nome">
              <template slot-scope="scope">
                {{ scope.row.nome }}
              </template>
            </el-table-column>
          </el-table>
        </el-main>
      </el-container>
    </el-col>

    <el-col :span="16" class="full-height">
      <el-container class="full-height">
        <el-header height="40px" style="padding: 10px 0px">
          <span style="color: #777; font-weight: bold">
            {{ `Cidades - ${form.id === 0 ? 'Nova Cidade' : `${form.nome}`}` }}
          </span>
        </el-header>

        <el-main class="full-height" style="background: #FFF; padding: 10px 0px 0px 0px">
          <div class="tab-container">
            <el-form 
              size="small"
              :model="form"
              :rules="validacao"
              ref="form"
              hide-required-asterisk
              :show-message="false"
            >
              <el-row :gutter="12">
                <el-col :span="8">
                  <el-form-item label="Nome" prop="nome">
                    <el-input size="small" v-model="form.nome"/>
                  </el-form-item>
                </el-col>

                <el-col :span="4">
                  <el-form-item label="UF" prop="estado">
                    <el-select
                      v-model="form.estado.id"
                      size="small"
                      clearable
                      clear
                    >
                      <el-option
                        v-for="item in estados"
                        :key="item.id"
                        :label="item.sigla"
                        :value="item.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>

              <div style="color: #777; font-weight: bold; font-size: 15px; margin-top: 10px" v-if="cidadeIsSelecionada">
                <i class="el-icon-document" />
                Variações de nome(p/Importação)
              </div>

              <div style="border: 2px solid #DDD; padding: 5px 10px; margin-top: 2.5px; height: 620px" v-if="cidadeIsSelecionada">
                <el-row :gutter="12">
                  <el-col :span="8">
                    <el-form-item label="Variação">
                      <el-input size="small" v-model="nomeVariacao"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-button @click="adicionarVariacao" size="small" style="width: 200px; margin-top: 5%" type="success">Adicionar</el-button>
                  </el-col>
                </el-row>
                <el-table
                  :data="form.variacoesNome"
                  height="90%"
                  style="width: 400px"
                  size="small"
                  highlight-current-row
                  stripe
                >
                  <el-table-column label="Variações">
                    <template slot-scope="scope">
                      {{ scope.row.nome }}
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form>
          </div>
        </el-main>

        <el-footer height="52px" style="background-color: #D1D1D1; padding: 10px 10px;">
          <el-row style="height: 100%">
            <el-col :span="24" style="height: 100%">
              <el-row type="flex" justify="end" style="padding-top: 0px;">
                <el-button @click="handleGravarCidade" size="small" type="success">Gravar</el-button>
                <el-button @click="confirmarRemoverCidade" size="small" type="danger" v-if="cidadeIsSelecionada">Remover</el-button>
              </el-row>
            </el-col>
          </el-row>
        </el-footer>

      </el-container>
    </el-col>
  </el-row>
</template>

<script>
import { ESTADOS } from '../../util/constantes'
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      nomeVariacao: '',

      validacao: {
        nome: [{ required: true }],
        estado: [{ type: "object", required: true,
          fields:{
            id: [{ required: true, type: "number" }]
          }
        }]
      }
    }
  },

  created() {
    this.handlerListarCidades();
  },

  computed: {
    ...mapState('cidadesStore', {
      form: (state) => {return state.form},
      formPesquisa: (state) => { return state.formPesquisa },
      listaCidades: (state) => { return state.cidades },
      quantidadeCidades: (state) => { return state.quantidadeCidades }
    }),
    estados() {
      return ESTADOS;
    },
    cidadeIsSelecionada() {
      return this.form.id !== 0;
    },

    labelQuantidadeCidades() {
      switch (this.quantidadeCidades) {
        case 0:
          return 'Nenhuma cidade foi encontrada';
        case 1: 
          return '1 cidade foi encontrada';
        default:
          return `${this.quantidadeCidades} cidades foram encontradas`; 
      }
    }
  },

  methods: {
    ...mapActions([
      'showLoading',
      'hideLoading'
    ]),
    ...mapActions('cidadesStore', [
      'listarCidades',
      'recuperarCidade',
      'limparForm',
      'gravarCidade',
      'removerCidade',
      'limparFormPesquisa',
      'gravarVariacoesNome'
    ]),

    handlerListarCidades() {
      const payload = {...this.formPesquisa}

      this.showLoading();

      this.listarCidades(payload)
      .then()
      .finally(() => {
        this.hideLoading();
      })
    },

    handleRecuperarCidade(cidade) {
      const payload = { id: cidade.id }

      this.showLoading();

      this.recuperarCidade(payload)
      .then()
      .finally(() => {
        this.hideLoading();
      });
    },

    handleGravarCidade() {
      this.$refs['form'].validate(valid => {
        if(valid) {
          const payload = { ...this.form }

          this.showLoading();

          this.gravarCidade(payload)
          .then(() => {
            this.$message.success('Cidade gravada com sucesso.')
            this.listarCidades({});
          })
          .finally(() =>{
            this.hideLoading();
          });
        } else {
          this.$message.warning('Insira os campos obrigatórios.')
        }
      });
    },

    confirmarRemoverCidade() {
      this.$confirm('Deseja realmente remover esta cidade?', 'Atenção', {
        confirmButtonTexto: 'Confirmar',
        cancelButtonText: 'Cancelar',
        type: 'warning'
      }).then(() => {
        this.handleRemoverCidade();
      }).catch(() => {})
    },

    handleRemoverCidade() {
      const payload = { ...this.form }

      this.showLoading();

      this.removerCidade(payload)
      .then((resposta) => {
        if(resposta.status === 'FALHA') {
          this.$message.warning(resposta.mensagem)
        } else {
          this.$message.success(resposta.mensagem)
        }

        this.listarCidades({});
      })
      .finally(() => {
        this.hideLoading();
      });
    },

    adicionarVariacao() {
      const variacao = {
        nome: this.nomeVariacao
      }

      this.form.variacoesNome = []
      
      this.form.variacoesNome.push(variacao);
      
      this.showLoading();
      this.gravarVariacoesNome(this.form)
      .then(() => {
        this.$message.success('Variação gravada com sucesso.')
      })
      .finally(() => {
        this.hideLoading();
      });
    },
  }
}
</script>